export const villainInfoMap: {
  [K: string]: {
    kor: string
    desc: string
    props: string[]
    choosingGuide: string
  }
} = {
  kongkong: {
    kor: '콩콩이',
    desc: `그러고 싶지 않은데, 자꾸 불안한가요?
    내 불안의 근원을 더 깊이 이해하고, 변화해 보세요!`,
    props: [
      '걱정이 꼬리에 꼬리를 물어, 닥치치 않은 일도 미리 걱정하는 "예기 불안"을 경험해요',
      "'내 결정에 자신이 없어', 자꾸 누군가에게 의지하고 싶어요.",
      '위험회피 성향이 높아 새로운 시도, 도전 앞에선 늘 망설여져요.',
      '불안할 때 근육통, 두근거림, 과호흡, 불면 등 신체적 증상을 겪기도 해요.',
    ],
    choosingGuide:
      '진학/취업 등 새로운 환경에 적응해야하는 상황에서 불안감. 사소한 일상 생활 일들을 처리하는데 긴장/부담감을 크게 느낌. 비관적인 걱정들이 몰려와 늘 불안함',
  },
  umgyuk: {
    kor: '엄격이',
    desc: `늘 완벽해야 하는 강박에 사로잡혀 있나요?
    스트레스 속에서 마음의 중심을 잡는 법을 배워요.`,
    props: [
      '더 높이, 더 많이! 목표치가 높고, 실수를 용납하기 어려워요.',
      "'제대로 해야 된다'라는 압박에 오히려 미리 포기하거나 시작을 미루기도 해요.",
      '일이 계획대로 흘러가지 않고 예상 밖의 변수가 생기면 불편해요.',
      '나도 모르게 긴장하고 무리하다 보면, 여기저기 몸이 아프기도 해요.',
    ],
    choosingGuide:
      '완벽주의, 미루기, 끊임없는 성취 욕구, 뒤쳐지는 것에 대한 불안감, 번 아웃, 쉼의 어려움',
  },
  mulung: {
    kor: '물렁이',
    desc: `주변 사람들에게 흔들리지 않고 싶나요?
    내 마음의 중심을 잡는 단단한 내가 되어보아요.`,
    props: [
      "'갈등 없는 관계'를 위해,  다른 사람에게 맞춰 주는 편이에요.",
      '거절 받는 것도, 거절하는 것도 어렵게 느껴져요.',
      '미움 받느니 손해 보는 게 낫다고 생각해요.',
      '왜 맨날 나만 참고 희생해야 하지? 라는 억울함이 쌓이기도 해요.',
    ],
    choosingGuide:
      '착한 아이 콤플렉스, 거절의 어려움, 대인관계 갈등(친구/연애 관계에서 소진감, 불만을 드러내기 어려움), 자존감 저하, 의사결정의 어려움. 가족이 버거움',
  },
  buruk: {
    kor: '버럭이',
    desc: `나도 모르게 버럭하고 후회한 적이 있나요?
    우아하게 화내고 행복한 버럭이가 되는 법을 배워요.`,
    props: [
      '일이 뜻대로 되지 않으면 나도 모르게 버럭! 화를 참기 어려워요.',
      '진짜 마음은 그게 아닌데, 화내지 않고 어떻게 표현할지 모르겠어요.',
      '버럭! 화내고 후회하지만, 비슷한 상황이 되면 다시 화를 조절하기 어려워요.',
      '반복되는 화로 주변 사람들과의 관계가 악화되면서 외롭기도 해요.',
    ],
    choosingGuide:
      '감정 조절의 문제, 인내심 혹은 억제력 부족, 화/짜증으로 인한 인간관계 갈등',
  },
  godok: {
    kor: '고독이',
    desc: `사람들 사이에서 자꾸만 지쳐 가나요?
    있는 그대로의 나로 맘 편히 살아가는 법을 배워요.`,
    props: [
      '혼자가 편하지만, 혼자 있으면 외롭고 허전하기도 해요.',
      '드러내고 싶지 않은, 남들과 다른 나의 모습이 있어요.',
      '남들이 진짜 나에 대해 알게 되면 실망하거나 비난하지 않을까 걱정돼요.',
      '누군가에게 이해와 지지, 사랑을 받을 수 있다는 기대가 적어요.',
    ],
    choosingGuide:
      '외로움, 사회불안, 위축감, 대인 관계에서 얼어붙음. 가족 내 소외. 내 편이 없는 듯한 느낌',
  },
}

export const percent: {
  byVillain: {
    [key: string]: {
      numTests: number
      byCl: Record<string, number>
    }
  }
  numTotalTests: number
} = {
  byVillain: {
    umgyuk: {
      numTests: 138,
      byCl: {
        0: 17,
        1: 49,
        2: 40,
        3: 32,
      },
    },
    buruk: {
      numTests: 138,
      byCl: {
        0: 19,
        1: 51,
        2: 37,
        3: 31,
      },
    },
    mulung: {
      numTests: 138,
      byCl: {
        0: 20,
        1: 53,
        2: 31,
        3: 34,
      },
    },
    godok: {
      numTests: 138,
      byCl: {
        0: 19,
        1: 53,
        2: 35,
        3: 31,
      },
    },
    kongkong: {
      numTests: 138,
      byCl: {
        0: 15,
        1: 60,
        2: 30,
        3: 33,
      },
    },
  },
  numTotalTests: 690,
}
